import { DropdownCard } from '../../../core/models/DigitalKit';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-info-drop-down',
    templateUrl: './info-drop-down.component.html',
    styleUrls: ['./info-drop-down.component.css'],
    standalone: false
})
export class InfoDropDownComponent implements OnInit {
@Input() dropdownCard!: DropdownCard;
  public hiddenExe: boolean = true;
  public hiddenServ: boolean = true;
  constructor() {

   }

  ngOnInit(): void {
  }
  showExe(){
    this.hiddenExe = false
  }
  showServ(){
    this.hiddenServ = false
  }
  hideServ(){
    this.hiddenServ = true
  }
  hideExe(){
    this.hiddenExe = true
  }
  /* scrollItem() {
    let el = document.getElementById('Exe');
    el?.scrollIntoView();
  } */
  
}
